<template>
  <div>
    <div class="failure_head" v-if="!show">
      <img src="@/assets/images/wxIcon.png" alt />
      <p>支付成功</p>
      <!-- <p  >￥{{resule.amount}}元</p> -->
      <div>
        尊敬的会员，本次购物完成后预计获得折上折金币
        <img class="gold-img" src="@/assets/images/goldIcon.png" alt="" />
        {{resule.gold}}个，获得的金币可提现或继续在平台购物使用
      </div>
    </div>
    <!-- <div class="score">
    <span>请为商家评分</span>
    <van-rate class="stars" v-model="value" color="#F44D4D" void-icon="star" void-color="#eee"></van-rate>
    <span class="attitude">好评</span>
    </div>-->
    <div class="btn" v-if="!show">
      <div class="btn_return btn_again" @click="onClickOrder">返回订单</div>
    </div>
    <van-overlay :show="show">
      <div class="wrapper" @click.stop>
        <div class="block">
          <van-loading size="50px" color="#F44D4D" vertical
            >正在查询支付结果...</van-loading
          >
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { getPayResult } from '@/api/themedata.js'
import increaseFpClickCountMixin from '@/mixins/increaseFpClickCountMixin'
import getIsWx from '@/mixins/getIsWx'
import { setTimeout } from 'timers'
import Cookies from 'js-cookie'

export default {
  name: 'PaySuccess',
  mixins: [increaseFpClickCountMixin, getIsWx],
  data() {
    return {
      exist: false,
      value: 5,
      id: this.$route.query.id,
      token: this.$route.query.token,
      clearTime: '',
      getDataInterval: null,
      resule: {
        amount: 0,
        orderId: 0,
        success: true,
        gold: 0,
      },
      show: true,
    }
  },
  created() {
    // console.log(
    //   '进来看链接路由',
    //   'this.token',
    //   this.token,
    //   'cookie',
    //   Cookies.get('token')
    // )
    window.document.title = '成功'
  },
  mounted() {
    // console.log('success mounted')
    this.id = this.$route.query.id
    if (this.$route.query.zero) {
      this.show = false
    } else {
      this.getDataInterval = setInterval(() => {
        this.getData()
      }, 2000)
    }
    if (this.$getUA() === 2 && !this.$getIsApp() && !this.$isWeixin()) {
      // 如果是IOS环境则跳转回App
      // console.log('是IOS浏览器环境')
      const currenturl = window.location.href
      window.location.href = currenturl.replace(
        currenturl.substring(0, currenturl.indexOf('//') - 1),
        'PuHui'
      )
      setTimeout(() => {
        alert('请打开普惠商城App查看支付结果')
      }, 3000)
    }
  },
  methods: {
    onClickOrder() {
      if (this.$getIsApp()) {
        this.$callApp('Android', 'ShowTabBarMethod', '')
        setTimeout(() => {
          this.$callApp('Android', 'GoOrderListMethod', '')
        }, 200)
        this.$callApp('iOS', 'GoOrderListMethod', '')
      }
    },
    async getData() {
      getPayResult(this.id).then((res) => {
        if (res.data.code === 200) {
          this.resule = res.data.data
          this.exist = res.data.data.success
          if (this.exist) {
            this.show = false
          } else {
            // 未查询到是成功状态，则继续查询
            if (!this.clearTime) {
              this.clearTime = setTimeout(() => {
                clearInterval(this.getDataInterval)
                // console.log(
                //   '圈圈加载token',
                //   this.token,
                //   'cookie',
                //   Cookies.get('token')
                // )
                if (this.exist) {
                  this.show = false
                } else {
                  let failReturnUrl
                  // console.log(
                  //   '查询结果else',
                  //   this.token,
                  //   'cookie',
                  //   Cookies.get('token')
                  // )
                  if (this.token && this.$getUA() == 1) {
                    Cookies.set('token', this.token)
                    failReturnUrl = `/themepage/error?id=${this.id}&token=${this.token}`
                    // console.log('有token时传递失败页', Cookies.get('token'))
                  } else {
                    failReturnUrl = `/themepage/error?id=${this.id}`
                    // console.log('没token时传递失败页', Cookies.get('token'))
                  }
                  this.$router.push({ path: failReturnUrl })
                }
              }, 10000)
            }
          }
        } else {
          this.show = false
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.failure_head {
  margin: 84px 50px 0;

  img {
    margin-left: 113.5px;
    width: 50px;
    height: 50px;
  }
  .gold-img {
    width: 25px;
    height: 25px;
    margin-left: 0;
    vertical-align: middle;
  }
  p:nth-of-type(1) {
    color: #39B523;
    margin: 10px 0px 15px 112.5px;
    font-size: 13px;
  }

  p:nth-of-type(2) {
    color: #121212;
    margin: 0px 0px 83.5px 93px;
    font-size: 20px;
  }
  div{
    color: #121212;
    font-size: 13px;
  }
}

//得分
.score {
  border-top: 1px solid #efefef;
  border-bottom: 1px solid #efefef;
  height: 53px;
  line-height: 53px;
  padding-left: 15px;

  span:nth-of-type(1) {
    line-height: 53px;
    font-size: 16px;
    color: #666666;
    padding-right: 10px;
  }

  /deep/ .van-icon {
    font-size: 20px;
  }

  .van-rate {
    vertical-align: middle;
    margin-bottom: 9px;
  }

  .attitude {
    margin-bottom: 10px;
    padding-left: 7.5px;
    font-size: 12px;
    color: #adadad;
  }

  /deep/ .van-rate__item:not(:last-child) {
    padding-right: 5px;
  }
}

//按钮
.btn {
  margin: 84px 50px 0;

  .btn_again {
    background-color: #FF986D;
    color: #fff;
    width: 275px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    font-size: 20px;
    border-radius: 25px;
    margin-bottom: 15px;
  }

  .btn_return {
    background: #FF986D;
    color: #fff;
    border: 1px solid #FF986D;
  }
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 250px;
  height: 250px;
  // background-color: #fff;
}
</style>
